import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[2/3] rounded-xl overflow-hidden bg-background-200/60">
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <p className="text-xs text-foreground-300 line-clamp-2 leading-relaxed">
              {movie.description}
            </p>
          </div>
        </div>

        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {movie.isHot && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-medium whitespace-nowrap">
              热门
            </span>
          )}
          {movie.isNew && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-md font-medium whitespace-nowrap">
              新上
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-background-50/80 backdrop-blur-sm text-primary-500 text-xs rounded-md font-bold whitespace-nowrap">
            {movie.rating}
          </span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 backdrop-blur-sm">
            <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-400">{movie.year}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{movie.duration}</span>
          {movie.type === 'tv' && (
            <>
              <span className="text-xs text-foreground-300">·</span>
              <span className="text-xs text-secondary-500 font-medium">剧集</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}